// extracted by mini-css-extract-plugin
export default {"arrow":"_2bSCG5dZgKvCvp8oqFjhDI"};